import React from 'react';
import TbodyTableMarcas from './tbody';
import TheadTableMarcas from './thead';
const TableMarcas = (props) => {
  const { loadingTables } = props.data;
  return (
    <div className="overflow-x-auto">
      {!loadingTables && (
        <table className="w-full table-auto text-sm">
          <TheadTableMarcas />
          <TbodyTableMarcas actions={props.actions} />
        </table>
      )}
    </div>
  );
};
export default TableMarcas;
